import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { normalizeRouteParam } from "@/utils/v2/routes";

import LoadingScreen from "@/components/v2/Loaders/LoadingScreen.vue";
import { useTask } from "@/composables/tasks/useTask";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { tasks } = useTask();

const taskKey = normalizeRouteParam(route.params.key)

const redirectToTaskType = (objective: string) => {
  const routes = {
    mortality: { name: "MortalityCheckOverview", params: { key: taskKey, refresh: Date.now() } },
    vaccination: { name: "VaccineConfigurations", params: { key: taskKey, refresh: Date.now() } },
    challenge: { name: "ChallengeConfigurations", params: { key: taskKey, refresh: Date.now() } },
    environmental: { name: "EnvironmentalCheck", params: { key: taskKey, refresh: Date.now() } },
    pre_challenge: { name: "PreChallenge", params: { key: taskKey, refresh: Date.now() } },
    fish_transfer: { name: "AnimalTransfer", params: { key: taskKey, refresh: Date.now() } },
    fish_import: { name: "FishImportImports", params: {key: taskKey, refresh: Date.now()} },
    environmental_modifier: { name: "EnvironmentalModifier", params: {key: taskKey, refresh: Date.now()} },
  } as const;

  const targetRoute = routes[objective as keyof typeof routes];
  if (targetRoute) {
    router.replace(targetRoute);
  } else {
    console.error("Unknown task objective:", objective);
  }
};

const init = async () => {
  const task = tasks.value.find(task => task.key === taskKey);
  if (task) {
    const objectiveId = task.objective?.id || task.objective;
    return redirectToTaskType(objectiveId);
  } else {
    alert("Cannot initiate task start");
  }
}
onMounted(init)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LoadingScreen, { text: 'Starting task...' }))
}
}

})